/* Press inventory, worldwide — client-side filter + sort.
   Country chips · Country pills · Type pills (4 sub-formats) · Sort dropdown.
   Filters the .pam-card grid by data attributes. Per-format empty-state
   messaging surfaces when a sub-format pill with zero inventory is picked. */
(function () {
  function init() {
    var root = document.querySelector("[data-pam-root]");
    if (!root) return;
    var cards = Array.from(root.querySelectorAll(".pam-card"));
    var grid = root.querySelector(".pam-grid");
    var emptyEl = root.querySelector("[data-pam-empty]");
    var emptyHEl = root.querySelector("[data-pam-empty-h]");
    var emptyPEl = root.querySelector("[data-pam-empty-p]");
    var countEl = root.querySelector("[data-pam-count]");
    var sortSel = root.querySelector("[data-pam-sort]");
    var pillsCountry = root.querySelectorAll("[data-pam-country]");
    var pillsType = root.querySelectorAll("[data-pam-type]");
    var chips = root.querySelectorAll("[data-pam-chip]");

    var state = { country: "all", type: "all", sort: "featured" };
    var originalOrder = cards.slice();

    function activatePill(list, val) {
      list.forEach(function (b) {
        b.classList.toggle("is-active", b.getAttribute("data-value") === val);
      });
    }

    function activeTypePill() {
      for (var i = 0; i < pillsType.length; i++) {
        if (pillsType[i].getAttribute("data-value") === state.type) return pillsType[i];
      }
      return null;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (c) {
        var country = c.getAttribute("data-country") || "";
        var type = c.getAttribute("data-type") || "";
        var matchCountry = state.country === "all" || country === state.country;
        var matchType = state.type === "all" || type === state.type;
        if (matchCountry && matchType) {
          c.classList.remove("is-hidden");
          visible++;
        } else {
          c.classList.add("is-hidden");
        }
      });
      if (countEl) countEl.textContent = visible;

      if (emptyEl) {
        if (visible === 0) {
          var pill = activeTypePill();
          var customH = pill ? pill.getAttribute("data-empty-h") : null;
          var customP = pill ? pill.getAttribute("data-empty-p") : null;
          if (emptyHEl) emptyHEl.innerHTML = customH || "No publications match these filters.";
          if (emptyPEl) emptyPEl.textContent = customP || "Try clearing the filters, or send a brief and we will source for you.";
          emptyEl.classList.add("is-on");
        } else {
          emptyEl.classList.remove("is-on");
        }
      }

      activatePill(pillsCountry, state.country);
      activatePill(pillsType, state.type);
    }

    function sortCards() {
      var sorted = originalOrder.slice();
      if (state.sort === "price-asc") {
        sorted.sort(function (a, b) {
          return Number(a.getAttribute("data-price") || 0) - Number(b.getAttribute("data-price") || 0);
        });
      } else if (state.sort === "price-desc") {
        sorted.sort(function (a, b) {
          return Number(b.getAttribute("data-price") || 0) - Number(a.getAttribute("data-price") || 0);
        });
      } else if (state.sort === "name") {
        sorted.sort(function (a, b) {
          return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || "");
        });
      }
      sorted.forEach(function (c) { grid.appendChild(c); });
    }

    pillsCountry.forEach(function (b) {
      b.addEventListener("click", function () {
        state.country = b.getAttribute("data-value");
        apply();
      });
    });
    pillsType.forEach(function (b) {
      b.addEventListener("click", function () {
        state.type = b.getAttribute("data-value");
        apply();
      });
    });
    chips.forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-value");
        state.country = (state.country === v) ? "all" : v;
        apply();
        var f = root.querySelector(".pam-filters");
        if (f) f.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
    if (sortSel) {
      sortSel.addEventListener("change", function () {
        state.sort = sortSel.value;
        sortCards();
        apply();
      });
    }

    apply();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
